"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useLocalStorageStateBase_1 = require("./useLocalStorageStateBase");
/**
 * Used to track usages of `useLocalStorageState()` with identical `key` values. If we encounter
 * duplicates we throw an error to the user telling them to use `createLocalStorageStateHook`
 * instead.
 */
const initializedStorageKeys = new Set();
function useLocalStorageState(key, defaultValue) {
    const value = useLocalStorageStateBase_1.default(key, defaultValue);
    /**
     * Detects incorrect usage of the library and throws an error with a suggestion how to fix it.
     */
    react_1.useEffect(() => {
        if (initializedStorageKeys.has(key)) {
            throw new Error(`useLocalStorageState() doesn't support multiple instances with the same key.` +
                `Use createLocalStorageStateHook('${key}'). Example: https://bit.ly/39PfEcV`);
        }
        else {
            initializedStorageKeys.add(key);
        }
        return () => void initializedStorageKeys.delete(key);
    }, [key]);
    return value;
}
exports.default = useLocalStorageState;
